<template>
	<div>
		<q-table
			v-if="!add_test_screen"
			:data="tests"
			:columns="columns"
			:pagination.sync="server_pagination"
			@request="request"
			:loading="loading"
			row-key="id"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[0]"
			binary-state-sort
			class="q-mt-md"
		>
			<template slot="top" slot-scope="props" :props="props">
				<div class="col" />
				<q-btn
					color="secondary"
					icon="far fa-plus"
					:label="$t('new')"
					@click="showTest(0)"
					:disable="!manageLiveClasses"
				/>
			</template>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<q-tr slot="body" slot-scope="props" :props="props">
				<q-td auto-width key="id" :props="props">
					{{ props.row.id }}
				</q-td>

				<q-td key="title" :props="props">
					{{ props.row.title }}
				</q-td>

				<q-td key="live_class_test_type" :props="props">
					{{ $t(getTestType(props.row.live_class_test_type)) }}
				</q-td>

				<q-td key="qty_questions" :props="props">
					{{ props.row.qty_questions }}
				</q-td>

				<q-td key="qty_total_questions" :props="props">
					{{ props.row.qty_total_questions }}
				</q-td>

				<q-td key="qty_user_results" :props="props">
					{{ props.row.qty_user_results }}
				</q-td>

				<q-td auto-width key="status" :props="props">
					<q-chip
						small
						:icon="getIconStatus(props.row.status)"
						:color="getColorStatus(props.row.status)"
						class="full-width"
					>
						{{ $t(getStatus(props.row.status)) }}
					</q-chip>
				</q-td>

				<q-td key="available_in" :props="props">
					{{ props.row.available_in }}
				</q-td>

				<q-td key="test_score" :props="props">
					{{ props.row.test_score }}
				</q-td>

				<q-td key="actions" :props="props">
					<q-btn
						flat
						round
						color="primary"
						icon="far fa-pencil-alt"
						@click="showTest(props.row.actions)"
						:disable="!manageLiveClasses"
					>
						<q-tooltip>
							{{ $t('view_or_edit_tooltip') }}
						</q-tooltip>
					</q-btn>

					<q-btn
						flat
						round
						color="negative"
						icon="far fa-trash-alt"
						@click="confirmRemove(props.row.actions)"
						:disable="!manageLiveClasses"
					>
						<q-tooltip>
							{{ $t('delete_tooltip') }}
						</q-tooltip>
					</q-btn>
				</q-td>
			</q-tr>
		</q-table>

		<div class="row gutter-sm  q-mt-lg" v-if="!add_test_screen">
			<div class="col-xs-12 col-sm-3">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="$router.push({ name: 'admin_live_classes' })"
				/>
			</div>
		</div>

		<new-test
			:add_test_screen="add_test_screen"
			:id_live_class="id_live_class"
			:id_test="id_test"
			:test_types="test_types"
			@returnToTests="returnToTests()"
			@changeIdTest="changeIdTest"
		/>

		<q-dialog v-model="confirm_remove" @ok="removeTest()">
			<span slot="title">{{ $t('remove_item') }}</span>

			<span slot="message">{{ $t('confirm_remove_item') }}</span>

			<template slot="buttons" slot-scope="props" :props="props">
				<q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
				<q-btn color="negative" :label="$t('remove')" @click="removeTest()" />
			</template>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as moment from 'moment'
import TestTabNewTest from 'components/admin/live_classe/TestTabNewTest'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'admin', 'live_classes', 'training'] },

	components: {
		'new-test': TestTabNewTest,
	},

	props: ['manageLiveClasses'],

	data() {
		return {
			id_live_class: '',
			id_test: '',
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 0,
				descending: false,
				sortBy: null,
			},
			tests: [],
			columns: [
				{
					align: 'left',
					field: 'id',
					label: '#',
					name: 'id',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'title',
					label: 'test',
					name: 'title',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'live_class_test_type',
					label: 'test_type',
					name: 'live_class_test_type',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'qty_questions',
					label: 'questions_quantity',
					name: 'qty_questions',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'qty_total_questions',
					label: 'number_of_questions_displayed',
					name: 'qty_total_questions',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'qty_user_results',
					label: 'realizations_quantity',
					name: 'qty_user_results',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'status',
					label: 'status',
					name: 'status',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'available_in',
					label: 'avaliable_in',
					name: 'available_in',
					required: true,
					sortable: true,
				},
				{
					align: 'left',
					field: 'test_score',
					label: 'test_score',
					name: 'test_score',
					required: true,
					sortable: true,
				},
				{
					align: 'right',
					field: 'edit',
					label: '',
					name: 'actions',
					required: true,
					sortable: false,
				},
			],
			loading: false,
			add_test_screen: false,
			action_id: '',
			confirm_remove: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			test_types: 'registration_lists/live_class_test_types',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},
	},

	methods: {
		request({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				search: this.filter,
				ordering: order_by,
			}

			this.$axios
				.get(
					`/admin_live_classes/live_classes/${
						this.id_live_class
					}/tests/?${this.$qs.stringify(data)}`,
					this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count
					this.tests = []

					this.tests = response.data.results.map((e) => ({
						...e,
						available_in: e.available_in
							? moment(e.available_in)
									.tz('Etc/GMT')
									.format('DD/MM/YYYY')
							: '',
						test_score: e.test_score !== 0 ? e.test_score : '',
						qty_total_questions: e.qty_total_questions
							? e.qty_total_questions
							: e.qty_questions,
						actions: e.id,
					}))
					this.loading = false
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
		},

		confirmRemove(id) {
			this.action_id = id
			this.confirm_remove = true
		},

		removeTest() {
			this.$q.loading.show()

			this.$axios
				.delete(
					`/admin_live_classes/live_classes/${this.id_live_class}/tests/${
						this.action_id
					}/`,
					this.getHeader
				)
				.then(() => {
					this.$q.loading.hide()

					this.request({
						pagination: this.server_pagination,
					})

					this.confirm_remove = false

					this.$q.notify({
						message: this.$t('item_removed_success'),
						type: 'positive',
						icon: 'far fa-trash-alt',
					})
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		showTest(id) {
			this.id_test = id
			this.add_test_screen = true
		},

		getTestType(id) {
			let obj = this.test_types.find((obj) => {
				return obj.value === id
			})
			if (obj) return obj.slug
			else return ''
		},

		getStatus(status) {
			if (status == 1) return 'published_f'
			else if (status == 2) return 'unpublished_f'
			else if (status == 3) return 'deleted'
		},

		getIconStatus(status) {
			if (status == 1) return 'fas fa-check'
			else if (status == 2) return 'fas fa-ban'
			else if (status == 3) return 'fas fa-trash-alt'
		},

		getColorStatus(status) {
			if (status == 1) return 'positive'
			else if (status == 2) return 'warning'
			else if (status == 3) return 'negative'
		},

		changeIdTest(id) {
			this.id_test = id
		},

		returnToTests() {
			window.scrollTo(0, 0)

			this.request({
				pagination: this.server_pagination,
			})

			this.id_test = ''
			this.add_test_screen = false
		},
	},

	created() {
		this.id_live_class = this.$route.params.id

		this.request({
			pagination: this.server_pagination,
		})
	},
}
</script>

<style></style>
